import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/google.png'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 1,
  class: ""
}
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  key: 2,
  class: ""
}
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "flex items-center space-x-2.5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"15px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_GoogleScopesButton = _resolveComponent("GoogleScopesButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          size: 'lg',
          class: "absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2"
        }))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.outstandingScopes.length === _ctx.scopes.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "noScopes", {}, () => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("integrations.classroom.grant_scopes_to_use_integration")), 1)
          ])
        ]))
      : (
				!_ctx.loading &&
				_ctx.outstandingScopes.length > 0 &&
				_ctx.outstandingScopes.length < _ctx.scopes.length
			)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "outstandingScopes", {}, () => [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("integrations.classroom.grant_scopes_to_use_integration")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.outstandingScopes.length > 0)
      ? (_openBlock(), _createBlock(_component_GoogleScopesButton, {
          key: 3,
          getUrl: () => _ctx.googleIntegrationStore.getClassroomScopesAuthUrl(_ctx.role),
          onAuthDone: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadAuthorizedScopes()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("integrations.classroom.grant_scopes_btn")), 1)
            ])
          ]),
          _: 1
        }, 8, ["getUrl"]))
      : _createCommentVNode("", true)
  ]))
}